import React, { Suspense, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Route as ReactRoute, Redirect } from 'react-router-dom';
import loadable from '@loadable/component';

import * as ROUTE from 'src/routes/routes';
import Loader from 'src/components/Loader';
import { useUserClientQuery } from 'src/hooks/user';
import authToken from 'src/utils/auth';
import logger from 'src/utils/logger';

const Route = ({
  component,
  layout: Layout,
  async: asyncRouts,
  path,
  ...rest
}) => {
  const Component = asyncRouts ? loadable(component) : component;
  const [userData, setUserData] = useState();
  const [redirectToPasswordUpdate, setRedirectToPasswordUpdate] = useState(false);
  const [renderedComponent, setRenderedComponent] = useState(false);
  const getUser = useUserClientQuery();

  const executeGetUser = async () =>{
    const { data } = await getUser();
    setUserData(data);
  };

  useEffect(()=>{
    try {
      setRenderedComponent(true);
      const currentUserId = authToken()?.user?.id ?
        parseInt(authToken().user.id, 10) :
        null;
      if(currentUserId) {
        executeGetUser();
      }
    }catch (err) {
      logger.error('Caught', err);
    }
  },[]);

  useEffect(()=>{
    setRedirectToPasswordUpdate(userData?.user?.needPasswordUpdate || false);
  },[userData]);

  const excludePagesFromPasswordUpdateRedirect = [ROUTE.SSO_AUTORIZE, ROUTE.SIGN_IN, ROUTE.SIGN_IN_CONFIRMATION, ROUTE.RESTORE_PASSWORD, ROUTE.SET_PASSWORD, ROUTE.PROFILE, undefined].includes(path);

  return (<>
    {renderedComponent ? <ReactRoute
      {...rest}
      path={path}
      render={props => (
        (redirectToPasswordUpdate && !excludePagesFromPasswordUpdateRedirect) ? (
          <Redirect to="/set-password/change-password" />
        ) : (
          <Layout path={path}>
            <Suspense fallback={<Loader />}>
              <Component {...props} />
            </Suspense>
          </Layout>
        )
      )}
    /> : null}
  
    
    </> );
};

/* Route.propTypes = {
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({})])
    .isRequired,
  layout: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({})]).isRequired,
  async: PropTypes.bool,
  path: PropTypes.string,
};

Route.defaultProps = {
  async: false,
}; */

export default Route;
